var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedStates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5136_5168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5217 10.9985H22C22 10.0057 21.8676 9.04384 21.621 8.12891H10.5217V10.9985Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5217 5.26021H20.3855C19.7121 4.16141 18.8511 3.19019 17.8473 2.39062H10.5217V5.26021Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 21.9987C13.5887 21.9987 15.9682 21.1039 17.8472 19.6074H4.15259C6.03161 21.1039 8.41109 21.9987 10.9999 21.9987Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.61447 16.7387H20.3855C20.926 15.8566 21.3453 14.8924 21.621 13.8691H0.378906C0.654637 14.8924 1.07388 15.8566 1.61447 16.7387Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09541 1.7178H6.09782L5.1654 2.39521L5.52157 3.4913L4.58919 2.81389L3.65681 3.4913L3.96447 2.54439C3.14351 3.22824 2.42395 4.02944 1.83098 4.92216H2.15218L1.55865 5.35335C1.46618 5.50761 1.37749 5.66431 1.2925 5.82334L1.57592 6.69565L1.04715 6.31146C0.915707 6.58994 0.79548 6.8747 0.687414 7.16538L0.999668 8.12651H2.15218L1.21975 8.80391L1.57592 9.9L0.643543 9.2226L0.0850352 9.62839C0.0291328 10.0778 0 10.5355 0 11H11C11 4.92491 11 4.2087 11 0C8.82698 0 6.80131 0.630352 5.09541 1.7178ZM5.52157 9.9L4.58919 9.2226L3.65681 9.9L4.01298 8.80391L3.08056 8.12651H4.23307L4.58919 7.03042L4.94532 8.12651H6.09782L5.1654 8.80391L5.52157 9.9ZM5.1654 5.59956L5.52157 6.69565L4.58919 6.01825L3.65681 6.69565L4.01298 5.59956L3.08056 4.92216H4.23307L4.58919 3.82607L4.94532 4.92216H6.09782L5.1654 5.59956ZM9.46722 9.9L8.53484 9.2226L7.60246 9.9L7.95863 8.80391L7.02621 8.12651H8.17871L8.53484 7.03042L8.89097 8.12651H10.0435L9.11105 8.80391L9.46722 9.9ZM9.11105 5.59956L9.46722 6.69565L8.53484 6.01825L7.60246 6.69565L7.95863 5.59956L7.02621 4.92216H8.17871L8.53484 3.82607L8.89097 4.92216H10.0435L9.11105 5.59956ZM9.11105 2.39521L9.46722 3.4913L8.53484 2.81389L7.60246 3.4913L7.95863 2.39521L7.02621 1.7178H8.17871L8.53484 0.621715L8.89097 1.7178H10.0435L9.11105 2.39521Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5136_5168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedStates);
export default __webpack_public_path__ + "static/media/unitedStates.48b85d1dc3e542471a3c259839359368.svg";
export { ForwardRef as ReactComponent };